export enum LinkRelTypes {
    PREFETCH = 'prefetch',
    PRELOAD = 'preload',
    STYLESHEET = 'stylesheet'
}

export enum LinkAsTypes {
    DOCUMENT = 'document',
    SCRIPT = 'script',
    STYLE = 'style',
    IMAGE = 'image'
}